export const SET_OUTLET_LIST = "set-out-list";
export const SET_EDIT_OUTLET_ID = "set-edit-outlet-id";
export const SET_EDIT_OUTLET = "set-edit-outlet";
